.container {
  --containerHeight: 1300px;
  max-width: var(--containerHeight);
  margin: auto;
}

.productDescriptionContainer {
  --containerHeight: 1300px;
  max-width: var(--containerHeight);
  margin: auto;
  padding: 0 10vw;
}

.contentContainer {
  display: flex;
  gap: 3.1em;
}

/* I M A G E  /  L E F T  C O N T A I N E R */
.leftContainer {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.image {
  width: 100%;
  border-radius: 3px;
}

/* C O N F I G U R A T O R  /  R I G H T  C O N T A I N E R */
.detailsContainer {
  min-width: 450px;
}

.rightContainer {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 400px;
}

.title {
  font-size: 24px;
  font-weight: 400;
  margin-bottom: 40px;
  margin-block: 0;
}

.visuallyHiddenTitle {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* D I M E N S I O N S */
.dimensionsTitleLabel,
.colorsTitleLabel {
  display: flex;
}

.dimensionsHeaderTitle {
  margin-top: 9px;
  margin-bottom: 9px;
  margin-right: 8px;
}

.dimensionsGrid {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.dimensionLabel {
  display: flex;
  align-items: center;
  min-width: 0;
}

.dimensionTitle,
.furnitureTitle {
  margin: 13px 0 10px 0;
  gap: 5px;
}

.dimensionTitle {
  flex: 0 0 auto;
}

.dimensionControl {
  flex: 1 1 auto; /* заполнить доступное */
  min-width: 0; /* разрешить сжатие содержимого */
}

.tooltipContainer {
  position: relative;
  cursor: pointer;
}

.tooltipContainer .tooltipText {
  visibility: hidden;
  width: 75px;
  color: #fffdf7;
  text-align: center;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: calc(100% + 5px);
  margin-left: -45px;
}

.tooltipContainer:hover {
  cursor: pointer;
}

.tooltipContainer:hover .tooltipText {
  visibility: visible;
  cursor: pointer;
}

.tooltipContainer:hover .tooltipText img {
  max-width: 100%;
  height: auto;
  border-radius: 50%;
  border: 1px solid #555;
}

/* --- NEW: used only for the dimensions title tooltip --- */
.dimensionsTooltipContainer {
  position: relative;
  display: inline-flex;
  margin-top: 10px;
  /*align-items: center;*/
  cursor: pointer;
}

/* M O D A L  1 */
.modalChildren {
  display: flex;
  flex-direction: row;
  gap: 30px;
  margin: 30px;
}

.modalText {
  font-size: 14px;
  margin: 0;
  text-align: start;
}

.modalImg {
  width: 200px;
  height: auto;
}

/* M O D A L  2 */
.imageSelectContainer {
  display: flex;
  justify-content: center;
  padding: 10px 0;
}

.modalSaveButton {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

/* C O M M O N */
.dimensionTitle,
.colorsTitleLabel,
.furnitureLabel p,
.sectionsLabel p,
.sectionLabel p,
.mirroringLabel p,
.sectionArrangementLabel p,
.shelfArrangement p,
.furnitureTitle,
.sectionTitle {
  font-size: 13px;
  width: 150px;
  flex-shrink: 0;
}

.sectionTitle,
.dimensionsTitleLabel,
.colorsTitleLabel,
.dimensionsHeaderTitle,
.furnitureHeaderTitle,
.subtitle,
.sectionsTitle {
  font-size: 15px;
  font-weight: 400;
}

.sectionLabel,
.mirroringLabel,
.dimensionTitle,
.furnitureTitle {
  display: flex;
  align-items: center;
}

/* C O L O R S */
.colorsLabel {
  display: flex;
  margin-top: 20px;
}

/* C O L U M N S */
.individualColumnsLabel {
  display: flex;
  margin-top: 20px;
  width: 100%;
}

.columnsConfig {
  /* flex: 1 1 auto;       */
  min-width: 0;
  /* box-sizing: border-box; */
}

.wardrobeColumnsSection {
  overflow-x: auto;
}

/* F U R N I T U R E */
.furnitureLabel {
  display: flex;
  align-items: center;
}

.furnitureConfig {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* A R A N J A R E   D U L A P   S I   R A F T U R I */
.mirroringLabel {
  margin-top: 10px;
}

.mirroringLabel p,
.shelfArrangement p,
.sectionArrangementLabel p {
  margin: 0;
}

.sectionArrangementLabel,
.shelfArrangement {
  display: flex;
  margin-top: 20px;
}

/* P R I C E */
.priceContainer,
.infoboxContainer {
  display: flex;
  flex-direction: column;
  background-color: #fffdf7;
  border: 1px solid #c2c2c2;
  border-radius: 10px;
  padding: 30px 25px;
  width: 170px;
  gap: 8px;
}

.galleryColorContainer {
  display: flex;
  justify-content: end;
  margin-bottom: 10px;
}

.infoboxContainer {
  margin-top: 20px;
  color: #505050;
}

.infoboxTitle {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  font-weight: 300;
}

.infoboxContainer p,
.infoboxTitle p {
  margin: 4px 0;
}

.priceBlock {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 5px;
}

.priceBox {
  display: flex;
  align-items: center;
  margin-top: 15px;
}

.priceBreakdown {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 180px;
  padding: 4px 2px;
  font-size: 13px;
}

.priceBreakdownRow {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  white-space: nowrap;
}

.priceBreakdownTotal {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: 4px;
  padding-top: 4px;
  border-top: 1px solid rgba(255, 255, 255, 0.3);
  font-weight: 600;
  white-space: nowrap;
}

.price {
  margin: 0;
  font-size: 24px;
  font-weight: 500;
  color: #553333;
}

.newPrice {
  margin: 0;
  font-size: 20px;
  font-weight: 500;
  color: #553333;
}

.requestVisit {
  margin-top: 10px;
  margin-left: 150px;
}

@media (max-width: 768px) {
  .requestVisit {
    margin-left: 20px;
  }
}

.crossedPrice {
  margin: 2px 0 0 15px;
  color: #553333;
  font-weight: 200;
  font-size: 16px;
  text-decoration: line-through;
}

.priceCont {
  margin-top: 10px;
}

.priceTitleText {
  margin: 0;
  font-size: 14px;
  font-weight: 300;
}

.price h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 400;
  color: #505050;
}

.priceRow {
  display: flex;
  margin-top: 8px;
  justify-content: space-between;
  gap: 15px;
}

/* Opt-in delivery / assembly service section (in the controls area). */
.serviceSection {
  margin-bottom: 12px;
}
.serviceSectionTitle {
  margin: 0 0 6px;
  font-size: 13px;
  font-weight: 600;
  color: #333;
}
.serviceOptions {
  display: flex;
  flex-direction: row;
  gap: 6px;
}
.serviceOption {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 10px;
  border: 1px solid #e6e2db;
  border-radius: 9px;
  background: #fff;
  font-size: 13px;
  color: #333;
  cursor: pointer;
  transition:
    border-color 0.15s ease,
    background-color 0.15s ease,
    box-shadow 0.15s ease;
}
.serviceOption:hover {
  border-color: #d2ccc0;
}
.serviceOptionActive {
  border-color: #333;
  background: #faf8f4;
  box-shadow: inset 0 0 0 1px #333;
}
.serviceCheckbox {
  width: 15px;
  height: 15px;
  flex-shrink: 0;
  cursor: pointer;
  accent-color: #333;
}
.serviceLabel {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.servicePrice {
  font-weight: 600;
  color: #6b6b6b;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.serviceOptionActive .servicePrice {
  color: #333;
}
.requestVisitText {
  color: #505050;
  font-size: 13px;
}
.underBtnText {
  font-size: 11px;
  color: #505050;
  margin: 2px 0 0;
  display: flex;
  justify-content: center;
}

.addToCartButtonContainer {
  display: flex;
  gap: 5px;
  flex-shrink: 0;
}

.cartButtonWrapper {
  display: flex;
  flex-direction: column;
}

.cartButtonWrapper button,
.cartButtonWrapper a {
  white-space: nowrap;
}

.cartIconButton {
  width: 46px;
  height: 46px;
  border: 2px solid #505050 !important;
  border-radius: 50% !important;
  color: #505050 !important;
}
.cartIconButton:hover {
  background-color: #505050 !important;
  color: #fffdf7 !important;
}

.assemblyNote {
  color: #505050;
  font-size: 12px;
}

/* MODAL ORDER CONFIRMATION */
.buttonRow {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}

/*MOBILE CHIPS IN CONFIGURATOR PAGE FOR MOBILE*/
.mobileNavChipsRow {
  --btnselect-wrap: nowrap;
  --btnselect-ox: auto;

  /* hide scrollbar, keep swipe */
  scrollbar-width: none;
  -ms-overflow-style: none;
  margin: 0 0 15px;
}
.mobileNavChipsRow::-webkit-scrollbar {
  width: 0;
  height: 0;
}

/* IMPORTANT: disable snap so centering stays exact */
.mobileNavChipsRow {
  scroll-snap-type: none;
}

/* M O B I L E */
@media (max-width: 768px) {
  .contentContainer {
    flex-direction: column;
    gap: 1rem;
    padding: 0 1.5rem;
    width: 100%;
    box-sizing: border-box;
  }
  .detailsContainer {
    min-width: 0;
    width: 100%;
    box-sizing: border-box;
    margin-inline: auto;
  }
  .breadcrumbContainer {
    padding: 0 1.5rem;
  }
  .leftContainer {
    /*padding-bottom: 1rem;*/
    padding-bottom: 0.5rem;
    background-color: #fffdf7;
  }
  .title {
    font-size: 20px;
  }
  .dimensionTitle,
  .colorsTitleLabel,
  .furnitureLabel p,
  .sectionsLabel p,
  .sectionLabel p,
  .mirroringLabel p,
  .sectionArrangementLabel p,
  .shelfArrangement p,
  .dimensionTitle,
  .furnitureTitle {
    width: 130px;
  }
  .priceContainer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: auto;
    background: #fff;
    z-index: 2;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    border-radius: 0;
    flex-direction: row;
    justify-content: space-around;
    gap: 20px;
    padding: 15px 20px;
    align-items: center;
    box-sizing: border-box;
  }
  .infoboxContainer {
    margin-top: 40px;
    width: 100%;
    box-sizing: border-box;
  }
  .priceBlock {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .price {
    display: flex;
    justify-content: end;
    width: 70px;
    margin-top: 3px;
  }
  .price:first-child {
    width: 100px;
    align-items: end;
  }
  .price h2 {
    font-size: 22px;
  }
  .modalChildren {
    flex-direction: column;
    align-items: center;
    gap: 20px;
    margin: 10px;
  }
  .priceRow {
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }
  .priceBox {
    margin-top: 0;
  }
  .priceCont {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    z-index: 2;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    padding: 10px 16px;
    box-sizing: border-box;
    margin-top: 0;
  }

  .dimensionsGrid {
    margin-top: 5px;
    width: 100%;
  }
  .dimensionTitle {
    width: 90px;
  }

  .newPrice {
    font-size: 18px;
  }

  .crossedPrice {
    font-size: 14px;
  }
  .dimensionsQuestion {
    display: flex;
    align-items: center;
    margin-top: 10px;
    justify-content: center;
  }
  .dimensionsMobileTooltip,
  .requestVisitText {
    color: #505050;
  }
  .mobileCorePanel {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 15px;
    box-sizing: border-box;
  }

  .individualColumnsLabel {
    margin-top: 0;
    justify-content: center;
  }
  .furnitureLabel {
    justify-content: center;
  }

  .columnConfigurationSection {
    width: 80vw;
  }
}

@media (max-width: 350px) {
  .dimensionTitle,
  .dimensionsTitleLabel,
  .colorsTitleLabel,
  .furnitureLabel p,
  .sectionsLabel p,
  .sectionLabel p,
  .mirroringLabel p,
  .sectionArrangementLabel p,
  .shelfArrangement p,
  .furnitureTitle {
    width: 95px;
  }
}

@media (max-width: 413px) {
  .contentContainer {
    padding: 0 1rem;
  }

  .sectionArrangementLabel p {
    width: 100px;
  }
  .imageWrapper {
    width: 100%; /* fill the label’s width */
    display: flex;
    justify-content: center; /* center the ImageSelect inside */
  }
}

@media (max-width: 374px) {
  .sectionArrangementLabel p {
    width: 91px;
  }
  .imageWrapper {
    width: 100%; /* fill the label's width */
    display: flex;
    justify-content: center; /* center the ImageSelect inside */
  }
}

/* I N D I V I D U A L  C O L U M N S */
.columnConfigurationContent {
  margin-top: 8px;
}

.columnTypeImages {
  display: flex;
  gap: 12px;
  margin-top: 10px;
}

.columnTypeImage {
  flex: 1;
  border: 2px solid #e0e0e0;
  border-radius: 6px;
  padding: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  background-color: #fffdf7;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.columnTypeImage:hover {
  border-color: #b0b0b0;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.columnTypeImageSelected {
  border-color: #505050;
  border-width: 2px;
  background-color: #fffdf7;
}

.columnTypeIcon {
  width: 60px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #505050;
}

.columnTypeImageSelected .columnTypeIcon {
  color: #505050;
}

.columnTypeLabel {
  font-size: 13px;
  font-weight: 300;
  text-align: center;
  color: #505050;
}

.columnTypeImageSelected .columnTypeLabel {
  color: #505050;
  font-weight: 400;
}

.columnTypeCheckmark {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 20px;
  height: 20px;
  background-color: #505050;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 400;
}

@media (max-width: 768px) {
  .columnTypeImages {
    flex-direction: column;
  }
  .title {
    display: none;
  }
  .contentContainer {
    gap: 0.2rem;
  }
}

/* N E W  C O L U M N  C O N F I G U R A T I O N  S C R O L L */
.columnConfigScrollContainer {
  margin-top: 10px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: #ccc #fffdf7;
}

.columnConfigScrollContainer::-webkit-scrollbar {
  height: 8px;
}

.columnConfigScrollContainer::-webkit-scrollbar-track {
  background: #f0f0f0;
  border-radius: 4px;
}

.columnConfigScrollContainer::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

.columnConfigScrollContainer::-webkit-scrollbar-thumb:hover {
  background: #999;
}

.columnConfigRow {
  display: flex;
  gap: 10px;
  padding-bottom: 5px;
}

.columnConfigOption {
  border: 2px solid #e0e0e0;
  border-radius: 6px;
  padding: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  background-color: #fffdf7;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  min-height: 120px;
  min-width: 90px;
  max-width: 110px;
  flex-shrink: 0;
}

.columnConfigOption:hover {
  border-color: #b0b0b0;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}

.columnConfigSelected {
  border-color: #505050;
  border-width: 2px;
  background-color: #fffdf7;
}

.columnConfigIcon {
  width: 60px;
  height: 75px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #505050;
}

.columnConfigSelected .columnConfigIcon {
  color: #505050;
}

.columnConfigLabel {
  font-size: 11px;
  font-weight: 300;
  text-align: center;
  color: #505050;
  line-height: 1.2;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.columnConfigSelected .columnConfigLabel {
  color: #505050;
  font-weight: 400;
}

@media (max-width: 768px) {
  .columnConfigRow {
    gap: 8px;
  }

  .columnConfigOption {
    padding: 6px;
    min-height: 100px;
    min-width: 80px;
    max-width: 100px;
  }

  .columnConfigIcon {
    width: 50px;
    height: 62px;
  }

  .columnConfigLabel {
    font-size: 10px;
  }
}
